var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconKeyboardArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1274_27495",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1274_27495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 10.0001L7.24992 6.75008C7.09714 6.5973 7.02075 6.40286 7.02075 6.16675C7.02075 5.93064 7.09714 5.73619 7.24992 5.58341C7.4027 5.43064 7.59714 5.35425 7.83325 5.35425C8.06936 5.35425 8.26381 5.43064 8.41659 5.58341L12.2499 9.41675C12.3333 9.50008 12.3923 9.59036 12.427 9.68758C12.4617 9.7848 12.4791 9.88897 12.4791 10.0001C12.4791 10.1112 12.4617 10.2154 12.427 10.3126C12.3923 10.4098 12.3333 10.5001 12.2499 10.5834L8.41659 14.4167C8.26381 14.5695 8.06936 14.6459 7.83325 14.6459C7.59714 14.6459 7.4027 14.5695 7.24992 14.4167C7.09714 14.264 7.02075 14.0695 7.02075 13.8334C7.02075 13.5973 7.09714 13.4029 7.24992 13.2501L10.4999 10.0001Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKeyboardArrowRight);
export default __webpack_public_path__ + "static/media/icon_keyboard_arrow_right.f6bfbfe4dfd82ed99dd6472a35fd7a5f.svg";
export { ForwardRef as ReactComponent };